import { useEffect, useState } from "react";
import { useLantern, useSession } from "../hooks";
import { navigate } from "../router";
import { t, tn } from "../i18n";

// PasswordRequestsBanner tells admins that people who forgot their password
// asked for a link to set a new one, with the way to the People tab, where
// they make it.
export function PasswordRequestsBanner() {
  const session = useSession();
  const state = useLantern();
  const [n, setN] = useState(0);
  const admin = state.me?.role === "admin";
  const notices = state.passwordRequestNotices;
  useEffect(() => {
    if (!admin) return;
    session.api.passwordRequests().then(
      (r) => setN(r.requests.length),
      () => {},
    );
  }, [session, admin, notices]);
  if (!admin || n === 0) return null;
  return (
    <p className="banner password-banner">
      {tn(n, "{n} person asked for a link to set a new password.", "{n} people asked for a link to set a new password.")}{" "}
      <button onClick={() => navigate("/admin/accounts")}>{t("See who")}</button>
    </p>
  );
}
